import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import cn from "classnames";
import { Dropdown, NativeDropdown } from "@ebsco-ui/ebsco-ui";
import { isPhone } from "../../store/client";
import "./dropdown-wrapper.scss";

const DropdownWrapper = ({
  isNativeDevice,
  items,
  onChange,
  id,
  placeholder,
  selected,
  dropdownLabel,
  hideLabel,
  disabled,
  styleType
}) => {
  if (isNativeDevice) {
    return (
      <NativeDropdown
        onChange={onChange}
        id={id}
        label={{ value: dropdownLabel, display: !hideLabel }}
        initialSelectedValue={selected?.value}
        items={items}
        className="native-dropdown"
        placeholder={placeholder}
        disabled={disabled}
        styleType={styleType}
      />
    );
  }

  const getLabelPlacementModifiers = getBaseClassNameWith => {
    if (hideLabel) return "";
  };

  const downshiftOptions = {
    onSelectedItemChange: ({ selectedItem }) => onChange?.(selectedItem)
  };

  if (selected) {
    downshiftOptions.selectedItem = selected;
  }

  return (
    <Dropdown
      items={items}
      className="dropdown"
      hideLabel={hideLabel}
      placeholder={placeholder}
      disabled={disabled}
      styleType={styleType}
      variant="LISTBOX"
      downshiftOptions={downshiftOptions}
    >
      <Dropdown.Context>
        {({ getBlocksWith: getBaseClassNameWith }) => (
          <div
            className={cn(
              getBaseClassNameWith("__toggle-wrapper"),
              getLabelPlacementModifiers(getBaseClassNameWith)
            )}
          >
            <Dropdown.Label className={getBaseClassNameWith("__label")}>
              {dropdownLabel}
            </Dropdown.Label>
            <div className={getBaseClassNameWith("__menu-wrapper")}>
              <Dropdown.Toggle type="button" />
              <Dropdown.Menu>
                {items.map((item, index) => (
                  <Dropdown.Item
                    key={`${item.label}`}
                    item={item}
                    index={index}
                  >
                    {item.fontAwesomeIcon && (
                      <Dropdown.Icon icon={item.fontAwesomeIcon} />
                    )}
                    {item.label}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </div>
          </div>
        )}
      </Dropdown.Context>
    </Dropdown>
  );
};

export const DropdownItemType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  fontAwesomeIcon: PropTypes.oneOfType([PropTypes.string, PropTypes.array])
});

DropdownWrapper.defaultProps = {
  isNativeDevice: false
};

DropdownWrapper.propTypes = {
  items: PropTypes.arrayOf(DropdownItemType).isRequired,
  id: PropTypes.string.isRequired,
  dropdownLabel: PropTypes.string.isRequired,
  hideLabel: PropTypes.bool,
  onChange: PropTypes.func,
  selected: DropdownItemType,
  placeholder: PropTypes.string,
  labelPosition: PropTypes.oneOf(["block-start", "inline-start", "inline-end"]),
  matchToggleWidth: PropTypes.bool,
  disabled: PropTypes.bool,
  styleType: PropTypes.oneOf(["standard", "primary"])
};

const mapStateToProps = state => ({
  isNativeDevice: isPhone(state)
});

export { DropdownWrapper };
export default connect(mapStateToProps)(DropdownWrapper);
